var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4C8A5C",
    fillRule: "evenodd",
    d: "m15.682 4.986-1.485 1.336A6.97 6.97 0 0 1 16 11a7 7 0 0 1-5 6.706V16l-5 3 5 3v-2.231c4.007-.91 7-4.487 7-8.769a8.96 8.96 0 0 0-2.318-6.014M7 6l5-3-5-3v2.231C2.993 3.141 0 6.718 0 11c0 2.315.882 4.419 2.318 6.014l1.485-1.337A6.96 6.96 0 0 1 2 11a7 7 0 0 1 5-6.706z"
  })));
});
const SvgTbReloadGreenIcon = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTbReloadGreenIcon);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIyMiIgdmlld0JveD0iMCAwIDE4IDIyIj4KICAgIDxwYXRoIGZpbGw9IiM0QzhBNUMiIGZpbGwtcnVsZT0iZXZlbm9kZCIKICAgICAgICAgIGQ9Ik0xNS42ODIgNC45ODZsLTEuNDg1IDEuMzM2QTYuOTY4IDYuOTY4IDAgMCAxIDE2IDExYTcgNyAwIDAgMS01IDYuNzA2VjE2bC01IDMgNSAzdi0yLjIzMWM0LjAwNy0uOTEgNy00LjQ4NyA3LTguNzY5YTguOTU4IDguOTU4IDAgMCAwLTIuMzE4LTYuMDE0TTcgNmw1LTMtNS0zdjIuMjMxQzIuOTkzIDMuMTQxIDAgNi43MTggMCAxMWMwIDIuMzE1Ljg4MiA0LjQxOSAyLjMxOCA2LjAxNGwxLjQ4NS0xLjMzN0E2Ljk2MyA2Ljk2MyAwIDAgMSAyIDExYTcgNyAwIDAgMSA1LTYuNzA2VjZ6Ii8+Cjwvc3ZnPgo=";